<template>
	<teleport to="body">
		<transition name="app-shell-spinner-fade">
			<div
				v-if="eventStore.appShellBusy"
				class="app-shell-spinner-overlay flex items-center justify-center"
				aria-busy="true"
				aria-live="polite"
			>
				<n-spin :size="80" />
			</div>
		</transition>
	</teleport>
</template>

<script lang="ts" setup>
import { NSpin } from "naive-ui"
import { useEventsStore } from "@/stores/apps/events"

const eventStore = useEventsStore()
</script>

<style scoped lang="scss">
.app-shell-spinner-overlay {
	position: fixed;
	z-index: 4800;
	inset: 0;
	width: 100vw;
	height: 100vh;
	background: rgba(255, 255, 255, 0.35);
	backdrop-filter: blur(2px);
}

.app-shell-spinner-fade-enter-active,
.app-shell-spinner-fade-leave-active {
	transition: opacity 0.2s ease;
}

.app-shell-spinner-fade-enter-from,
.app-shell-spinner-fade-leave-to {
	opacity: 0;
}
</style>
